import { Footer } from "../First";

export function Subscription(){


    return (

        <>
        
        <h1> Subscription Page Bro</h1>
        <Footer />
        </>
    )
}

export default Subscription;